// First, on purpose: see boot.ts.
import "./boot";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initAnalytics } from "./lib/analytics";
import { isDemoTab, isImpersonationTab } from "./lib/auth/impersonation";
import { capturePrefilledSite } from "./lib/onboarding/site-prefill";
import "./index.css";

// Initialize analytics before rendering. Never in an operator's view of a
// member: their visit is not the member's activity. The public demo loads it
// for its own events only (task 405, `trackDemoEvent`).
if (!isImpersonationTab() || isDemoTab()) {
  initAnalytics();
}

// The site scanner's call to action arrives as `/signup?site=<host>` (task
// 293). Captured here, before React renders, rather than in the signup
// page's effect: that page is a lazy chunk, and a visitor who moves on
// before it mounts would lose the host.
if (window.location.pathname.replace(/\/$/, "") === "/signup") {
  capturePrefilledSite(window.location.search);
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
